<template>
  <div class="tw-pt-20" :class="parentGroup">
    <div class="tw-max-w-[900px] tw-mx-auto">
      <div class="tw-flex tw-mb-10">
        <div
          class="tw-grow tw-text-center tw-text-5xl tw-font-bold tw-mr-4 rule-title"
        >
          {{ category.spellingRuleName }}
        </div>
        <div class="tw-self-end">
          <SfRouterLink :to="'/'" class="sf-btn-primary tw-text-nowrap">
            Choose another category
          </SfRouterLink>
        </div>
      </div>
      <ul>
        <HomeSpellingRule
          v-for="r in rules"
          :key="r.id"
          :rule="r"
          :parent-group="parentGroup"
          @show-word-list="wordListRule = $event"
          @show-printables="printablesRule = $event"
          @show-locked="lockedVisible = true"
          @show-results="showTestResults"
        />
      </ul>
      <ModalDialog
        :show="wordListRule != null"
        :is-simple="true"
        simple-ok-label="Close"
        @closed="wordListRule = null"
        @ok="wordListRule = null"
      >
        <template v-slot:title>
          {{ printablesRule?.spellingRuleName }}
        </template>
        <WordList :spelling-rule="wordListRule" class="sf-modal-body" />
      </ModalDialog>
      <SpellingPrintablesModal
        :show="printablesRule != null"
        :category-id="printablesRule?.id"
        @close="printablesRule = null"
        @closed="printablesRule = null"
      >
        <template v-slot:title>
          {{ printablesRule?.spellingRuleName }}
        </template>
      </SpellingPrintablesModal>
      <LockedUserModal :show="lockedVisible" @closed="lockedVisible = false" />
      <TestResultModal
        :test-result-info="detailsResultInfo"
        subject="spelling"
        :student="$currentUser.value"
        @closed="detailsResultInfo = null"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.first .rule-title {
  @apply tw-text-color5;
}

.middle .rule-title {
  @apply tw-text-color2;
}

.last .rule-title {
  @apply tw-text-primary;
}
</style>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { SfWordCategory } from "@/types/spellingTypes";
import { PropType } from "vue";
import { defineComponent } from "vue";
import SfRouterLink from "../shared/SfRouterLink.vue";
import HomeSpellingRule from "./HomeSpellingRule.vue";
import ModalDialog from "../ui/ModalDialog.vue";
import WordList from "../shared/WordList.vue";
import SpellingPrintablesModal from "../school-shared/SpellingPrintablesModal.vue";
import LockedUserModal from "../shared/LockedUserModal.vue";
import TestResultModal from "../school-shared/TestResultModal.vue";
import { SfTestResultInfo } from "@/types/generalTypes";

export default defineComponent({
  components: {
    SfRouterLink,
    HomeSpellingRule,
    ModalDialog,
    WordList,
    SpellingPrintablesModal,
    LockedUserModal,
    TestResultModal,
  },
  props: {
    category: { type: Object as PropType<SfWordCategory>, required: true },
    parentGroup: {
      type: String as PropType<"first" | "middle" | "last" | "">,
      default: "",
    },
  },
  data() {
    return {
      rules: [] as SfWordCategory[],
      wordListRule: null as SfWordCategory | null,
      printablesRule: null as SfWordCategory | null,
      lockedVisible: false,
      detailsResultInfo: null as SfTestResultInfo | null,
    };
  },
  mounted() {
    this.refreshRules();
  },
  methods: {
    async refreshRules() {
      const res = await apiCall("spelling-rule/home/" + this.category.id);
      if (res.success) {
        this.rules = res.data.items;
      }
    },
    async showTestResults(rule: SfWordCategory) {
      this.detailsResultInfo = { wordCategoryId: rule.id };
    },
  },
});
</script>
